import { EntityBase } from './EntityBase';
import { Material } from './Material';
import { TypePrediction } from './TypePrediction';
import { TypePredictionClass } from './TypePredictionClass';

import { Validator } from 'breeze-client';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

export class Prediction extends EntityBase {

   /// <code> Place custom code between <code> tags
   
   /// </code>

   // Generated code. Do not place code below this line.
   predictionId: number;
   materialId: number;
   typePredictionId: number;
   predictionClass: string;
   comment: string;
   enabled: boolean;
   created: Date;
   createdUser: string;
   modified: Date;
   modifyUser: string;
   rowVersion: number;
   material: Material;
   typePrediction: TypePrediction;
   typePredictionClass: TypePredictionClass;
}

